/**
 * IMPORTS
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { Translate } from 'react-i18nify';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
import {
  Container,
  Button,
  Form as ReactForm,
} from 'reactstrap';

import TimeoutButton from '../TimeoutButton';

import SwitchInput from '../inputs/SwitchInput';
import {
  completeStep,
  cancelStep,
} from '../../actions/nav-actions';
import { addSessionData } from '../../actions/session-actions';
import { getProjectForm } from '../../actions/project-actions';
import {
  getCurrentFormBooleanFields,
  getFormInitialValues,
  getCurrentProjectId,
} from '../../selectors';

/**
 * CORE
 */

const TICKS_BEFORE_CANCEL = 60;

class Checkboxes extends Component {
  static stepId = 'checkboxes';

  static propTypes = {
    disabled: PropTypes.bool,
    fields: PropTypes.array,
    projectId: PropTypes.string.isRequired,
    addSessionData: PropTypes.func.isRequired,
    completeStep: PropTypes.func.isRequired,
    cancelStep: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    getProjectForm: PropTypes.func.isRequired,
  };

  static defaultProps = {
    disabled: false,
    fields: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      ticksBeforeCancel: TICKS_BEFORE_CANCEL,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentWillMount() {
    const { projectId } = this.props;
    this.props.getProjectForm(projectId);
  }

  onSubmit(data) {
    this.props.addSessionData(data);
    this.props.completeStep(Checkboxes.stepId);
  }

  onCancel(event) {
    if (event) {
      event.preventDefault();
    }

    this.props.cancelStep(Checkboxes.stepId);
  }

  render() {
    const { ticksBeforeCancel } = this.state;
    const {
      handleSubmit,
      fields,
      disabled,
    } = this.props;

    return (
      <Container>
        <ReactForm
          onSubmit={handleSubmit(this.onSubmit)}
          noValidate
        >
          {fields.map(({ name, ...rest }) => {
            const props = { name, key: name, i18nPath: 'Form', ...rest };
            return <SwitchInput {...props} />;
          })}
          <Translate
            value="Form.conditions"
            tag="h4"
          />
          <div>
            <TimeoutButton
              buttonProps={{
                className: 'mr-2 app-button',
                color: 'secondary',
                outline: true,
                size: 'lg',
                onClick: this.onCancel,
              }}
              ticks={ticksBeforeCancel}
              onTimeout={this.onCancel}
              disabled={disabled}
            >
              <FA icon={faTimes} />
              &nbsp;
              <Translate value="Form.cancel" />
            </TimeoutButton>
            <Button
              className="app-button"
              color="primary"
              size="lg"
            >
              <FA icon={faCheck} />
              &nbsp;
              <Translate value="Form.submit" />
            </Button>
          </div>
        </ReactForm>
      </Container>
    );
  }
}

export default compose(
  connect(
    state => ({
      projectId: getCurrentProjectId(state),
      fields: getCurrentFormBooleanFields(state),
      initialValues: getFormInitialValues(state),
    }),
    {
      completeStep,
      cancelStep,
      addSessionData,
      getProjectForm,
    },
  ),
  reduxForm({
    form: 'data-collect-checkboxes',
  }),
)(Checkboxes);
